// Per-page Arabic resource files.
//
// Add one file per page or section that needs translated copy. The English
// text stays in the JSX (it is the source of truth); Arabic values are
// looked up by a stable key. If the Arabic value is null/empty, the English
// original is rendered instead — this is the intentional fallback while
// translation is in progress.
//
// Convention: file name matches the page slug or the section name. Do not
// invent Arabic here — leave keys as `null` until a human writes the copy.

export const home = {
  hero: {
    h1: null,        // pending: hero headline
    sub: null,       // pending: hero sub-line
    ctaPrimary: null,
    ctaSecondary: null,
  },
  problem: {
    heading: null,
    body: null,
  },
  whatHappensNext: {
    heading: null,
    steps: [null, null, null, null, null],
  },
};

// Example placeholder for a service page. Replace `serviceSlug` with the
// real slug when Arabic copy for that page is delivered.
export const services = {
  // "custom-software-development-company-in-oman": { h1: null, intro: null, ... },
};

export const meyar = {
  overview: { h1: null, intro: null, sections: null },
  enterpriseGrc: { h1: null, intro: null },
  cyberSecurityGrc: { h1: null, intro: null },
};
